import request from '@/utils/request';

// 获取行政区划列表
export function getProvinceList(nodeId, data) {
  return request({
    url: "/api/system/Area/".concat(nodeId),
    method: 'GET',
    data: data
  });
}

// 获取行政区划下拉框数据
export function getProvinceSelector(id, currId) {
  return request({
    url: "/api/system/Area/".concat(id, "/Selector/").concat(!!currId ? currId : 0),
    method: 'GET'
  });
}

// 添加行政区划
export function createProvince(data) {
  return request({
    url: '/api/system/Area',
    method: 'POST',
    data: data
  });
}

// 修改行政区划
export function updateProvince(data) {
  return request({
    url: "/api/system/Area/".concat(data.id),
    method: 'PUT',
    data: data
  });
}

// 获取行政区划信息
export function getProvinceInfo(id) {
  return request({
    url: "/api/system/Area/".concat(id, "/Info"),
    method: 'GET'
  });
}

// 删除行政区划信息
export function delProvince(id) {
  return request({
    url: "/api/system/Area/".concat(id),
    method: 'DELETE'
  });
}

// 更新行政区划状态
export function updateProvinceState(id) {
  return request({
    url: "/api/system/Area/".concat(id, "/Actions/State"),
    method: 'PUT'
  });
}